import React from 'react';
import "./ExaminationProcessCards.css"
const ExaminationProcessCards = () => {
  const processSteps = [
    {
      id: 11,
      title: "Planning of job roles and locations of all available Exam Manpower",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="3"/>
          <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      bgColor: "#f8f9ff"
    },
    {
      id: 12,
      title: "Timed Mock Drill (with full manpower) of actual exam with Mock data, with fault tolerance of Power/Server/Network",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8"/>
          <path d="M21 21L16.65 16.65"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      bgColor: "#fff8f9"
    },
    {
      id: 13,
      title: "Sealing of PC Nodes after verification at the unit level",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14,2 14,8 20,8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10,9 9,9 8,9"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      bgColor: "#f0fdff"
    },
    {
      id: 14,
      title: "Exam conduction strictly as per guidelines, instructions, data, and timeline",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/>
          <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      bgColor: "#f0fffe"
    },
    {
      id: 15,
      title: "Local reporting and monitoring by dedicated state/city heads",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      bgColor: "#fffdf0"
    },
    {
      id: 16,
      title: "Ensuring daily/final data backup, documentation, data upload, and status feedback",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      bgColor: "#f9fffe"
    },
    {
      id: 17,
      title: "Ensuring final clean-up of deployed and accumulated data/documents before leaving center",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
          <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
          <path d="M4 22h16"/>
          <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
          <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
          <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
        </svg>
      ),
      color: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)",
      bgColor: "#fefffe"
    }
  ];

  return (
    <div style={{ 
      marginBottom:"30px", 
      backgroundColor: '#f8f9fa',
      padding: '40px 0'
    }}>
      <div className="container">
        {/* Header Section */}
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h3 className="text-danger mb-4 title split-collab" style={{fontWeight : 800,fontSize: "clamp(1.5rem, 5vw, 3.2rem)"}} >
              EXAMINATION PROCESS MANAGEMENT 2
            </h3>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="row g-4"
         data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800">
          {processSteps.map((step, index) => (
            <div key={step.id} className="col-lg-3 col-md-4 col-sm-6 col-12">
              <div 
                className="card h-100"
                style={{
                  border: '1px solid #e9ecef',
                  borderRadius: '15px',
                  background: step.bgColor,
                  overflow: 'hidden',
                  position: 'relative'
                }}
              >
                {/* Decorative background element */}
                <div style={{
                  position: 'absolute',
                  top: '-50%',
                  right: '-20%',
                  width: '120px',
                  height: '120px',
                  background: step.color,
                  borderRadius: '50%',
                  opacity: '0.1',
                  zIndex: 0
                }}></div>

                <div className="card-body p-3" style={{ position: 'relative', zIndex: 1 }}>
                  {/* Step Number Badge */}
                  <div style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    width: '35px',
                    height: '35px',
                    background: step.color,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}>
                    {step.id}
                  </div>

                  {/* Icon Section */}
                  <div style={{
                    width: '60px',
                    height: '60px',
                    background: step.color,
                    borderRadius: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    color: '#fff'
                  }}>
                    <div style={{ transform: 'scale(0.8)' }}>
                      {step.icon}
                    </div>
                  </div>

                  {/* Content */}
                  <h6 style={{
                    fontSize: '1.6rem',
                    fontWeight: '600',
                    color: '#868a8f',
                    marginBottom: '15px',
                    lineHeight: '1.4',
                    minHeight: '60px',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {step.title}
                  </h6>


                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        {/* <div className="row mt-4">
          <div className="col-12 text-center">
            <p style={{
              color: '#6c757d',
              fontSize: '1rem',
              opacity: '0.8',
              fontWeight: '400'
            }}>
              Complete examination process workflow for seamless management
            </p>
          </div>
        </div> */}
      </div>

    </div>
  );
};

export default ExaminationProcessCards;